import type { ProFormItemProps } from '@ant-design/pro-components';
import { ProForm } from '@ant-design/pro-components';
import { Input } from 'antd';
import type { InputProps } from 'antd';
import React from 'react';

export interface ProFormTextSearchProps extends Omit<ProFormItemProps, 'fieldProps'> {
  name: string;
  label?: React.ReactNode;
  placeholder?: string;
  onSearch?: (
    value: string,
    event?:
      | React.ChangeEvent<HTMLInputElement>
      | React.MouseEvent<HTMLElement>
      | React.KeyboardEvent<HTMLInputElement>,
    info?: {
      source?: 'clear' | 'input';
    },
  ) => void;
  rules?: any[];
  fieldProps?: InputProps;
}

const ProFormTextSearch: React.FC<ProFormTextSearchProps> = ({
  placeholder,
  onSearch,
  fieldProps,
  ...rest
}) => (
  <ProForm.Item {...rest}>
    <Input.Search onSearch={onSearch} placeholder={placeholder} {...fieldProps} />
  </ProForm.Item>
);

export default ProFormTextSearch;
